import { Outlet } from '@tanstack/react-router'
import { Navbar } from './Navbar'
import { Footer } from './Footer'
import { Notifications } from '@/components/ui/Notifications'
import { JSX } from 'react/jsx-runtime'

export function PublicLayout(): JSX.Element {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Notifications />
    </div>
  )
}
